import React from "react";
import ReactDOM from "react-dom/client";
import Funker530 from "./Funker530";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Funker530 />);
